import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinStock from '@mixins/stock'
import MixinFats from '@mixins/fats'
import { Pawn } from '@/services/store/types'
import MixinPlayer from '@/mixins/player'
import ModalPlugin from '@plugins/modal/index'
import ModelMolecule from '@/models/molecule'

interface TagFat {
  pawnID: string | null
  moleculeID: string | null
  title: string
  chainLength: number
  doubleBinding: number
}

@Component({
  filters: {
    stripsubs(value: string) {
      value = value.replace('<sub>', '')
      value = value.replace('</sub>', '')
      return value
    },
  },
})
export default class CreateTag extends mixins(MixinStock, MixinFats, MixinPlayer) {
  public tagFats: TagFat[] = []
  private tagFatsLocal: { [key: string]: string | null } = {
    first: null,
    second: null,
    third: null,
  }

  get fat1() {
    return this.tagFatsLocal.first
  }

  set fat1(value) {
    this.tagFatsLocal.first = value
    this.resetFats('first', value)
  }

  get fat2() {
    return this.tagFatsLocal.second
  }

  set fat2(value) {
    this.tagFatsLocal.second = value
    this.resetFats('second', value)
  }

  get fat3() {
    return this.tagFatsLocal.third
  }

  set fat3(value) {
    this.tagFatsLocal.third = value
    this.resetFats('third', value)
  }

  get areAllFatSlotsTaken() {
    return !Object.values(this.tagFatsLocal).includes(null)
  }

  public mounted() {
    ModalPlugin.event.$on('open', (name: string, params: object) => {
      if (name === 'create-tag') {
        this.reset()
        this.defineFats()
      }
    })
  }

  public onCreateTag() {
    if (!this.areAllFatSlotsTaken) {
      return
    }

    this.removePawns()
    this.createTag()
    this.createCoA()
    this.checkGameWonByTeam()
    this.storeUpdatePawnAmount({
      player: this.activePlayer,
      amount: 1,
    })
    this.$modal.close('create-tag')
  }

  private removePawns() {
    this.storeRemovePawn({
      player: this.activePlayer,
      molecule: this.$molecules.find('do9lmqxm'),
    })

    Object.values(this.tagFatsLocal).forEach(() => {
      this.storeRemovePawn({
        player: this.activePlayer,
        molecule: this.$molecules.find('0p9dd69v'),
      })
    })
  }

  private createTag() {
    const tagMolecule: ModelMolecule = this.$molecules.find('j2971q94')

    const chainLengths = Object.values(this.tagFatsLocal)
      .map((pawnID) => {
        const tagFat: TagFat = this.tagFats.find((item) => item.pawnID === pawnID) as TagFat
        return tagFat.chainLength
      })

    const doubleBindings = Object.values(this.tagFatsLocal)
      .map((pawnID) => {
        const tagFat: TagFat = this.tagFats.find((item) => item.pawnID === pawnID) as TagFat
        return tagFat.doubleBinding
      })

    this.storeAddPlayerMolecule({
      player: this.activePlayer,
      ids: [tagMolecule.id, ...tagMolecule.mirrors],
      chainLengths,
      doubleBindings,
    })

    this.$flits.success('TAG is toegevoegd aan je moleculen.')
  }

  private createCoA() {
    this.storeUpdateTeamEnzyme({
      team: this.activeTeam,
      enzyme: this.$enzymes.find('9lq9j3vw'), // CoA
      quantity: 3,
    })
  }

  private reset() {
    this.tagFatsLocal = {
      first: null,
      second: null,
      third: null,
    }
  }

  private resetFats(key: string, value: string | null) {
    for (const i in this.tagFatsLocal) {
      if (i !== key && this.tagFatsLocal[i] === value) {
        this.tagFatsLocal[i] = null
      }
    }
  }

  private defineFats() {
    this.tagFats = this.playerTeamPawns
      .filter((pawn: Pawn) => pawn.moleculeID === '0p9dd69v')
      .sortBy((sortpawn: Pawn) => sortpawn.chainLengths[0])
      .transform((transformPawn: Pawn) => {
        return {
          pawnID: transformPawn.id,
          moleculeID: transformPawn.moleculeID,
          title: this.fatGetTitle(transformPawn.chainLengths[0], transformPawn.doubleBindings[0]),
          chainLength: transformPawn.chainLengths[0],
          doubleBinding: transformPawn.doubleBindings[0],
        }
      })
      .toArray()

    this.tagFats.unshift({
      pawnID: null,
      moleculeID: null,
      title: 'kies vetzuur',
      chainLength: 0,
      doubleBinding: 0,
    })
  }
}
